/* eslint-disable  @typescript-eslint/no-explicit-any */

import { DISPATCHES } from "../../InterfacesTypes/enums";
import type {
  IKeyWords,
  IOptionType,
  IQuickLinks,
  IStartPageText,
  IWebSites,
} from "../../InterfacesTypes/interfaces";

export function incramentAction(payload: number) {
  return {
    type: DISPATCHES.INCREMENT,
    payload,
  };
}

export function decramentAction(payload: number) {
  return {
    type: DISPATCHES.DECREMENT,
    payload,
  };
}

export function setMatchingKeyWordStrings(payload: any) {
  return {
    type: DISPATCHES.SET_MATCHING_KEYWORDS_STRINGS,
    payload,
  };
}

export function setMatchingKeyWordsArray(payload: any) {
  return {
    type: DISPATCHES.SET_MATCHING_INDIVIDUAL_KEYWORDS_ARRAY,
    payload,
  };
}

export function setMatchingWebSitesArray(payload: any) {
  return {
    type: DISPATCHES.SET_MATCHING_WEBSITES_ARRAY,
    payload,
  };
}

export function setQuickLinks(payload: IQuickLinks[]) {
  return {
    type: DISPATCHES.SET_QUICK_LINKS,
    payload,
  };
}

export function setUserHasAccessToDriftAndForvaltningLink(payload: boolean) {
  return {
    type: DISPATCHES.SET_USER_ACCESS_TO_RESTRICTED_LINKS,
    payload,
  };
}

export function searchResultDispatchAction(payload: any) {
  return {
    type: DISPATCHES.SEARCH_RESULT_DISPATCH_ACTION,
    payload,
  };
}

// Used to set user input in state
export function searchInputAction(payload: string) {
  return {
    type: DISPATCHES.SEARCH_INPUT_SET_ACTION,
    payload,
  };
}

// Used to set user selected keyword in state
export function setUserSelectedInputKeyWord(payload: IOptionType) {
  return {
    type: DISPATCHES.SET_USER_SELECTED_INPUT_KEYWORD,
    payload,
  };
}

export function setHandleKeyDownInput(payload: any) {
  return {
    type: DISPATCHES.SET_HANDLE_KEY_DOWN_INPUT,
    payload,
  };
}

export function searchInputResetAction() {
  return {
    type: DISPATCHES.SEARCH_INPUT_RESET_ACTION,
  };
}

// Action used to fetch SP KeyWords list data
export function getSPKeyWordsData(payload: IKeyWords[]) {
  return {
    type: DISPATCHES.GET_SP_KEYWORDS,
    payload,
  };
}

export function setSPKeyWordsData(payload: IKeyWords[]) {
  return {
    type: DISPATCHES.SET_SP_KEYWORDS,
    payload,
  };
}

// export function getUserSelectedInputKeyWord(payload: string) {
export function getUserSelectedInputKeyWord(payload: IOptionType) {
  return {
    type: DISPATCHES.GET_USER_SELECTED_INPUT_KEYWORD,
    payload,
  };
}

// Action used in Sagas.ts to set the start page texts
export function setStartPageText(payload: IStartPageText) {
  return {
    type: DISPATCHES.SET_STARTPAGE_TEXT,
    payload,
  };
}

// Action used to fetch SP WebSites list data
export function getSPWebSitesData(payload: IWebSites[]) {
  return {
    type: DISPATCHES.GET_SP_WEBSITES,
    payload,
  };
}

export function setSPWebSitesData(payload: IWebSites[]) {
  return {
    type: DISPATCHES.SET_SP_WEBSITES,
    payload,
  };
}

export function searchKeyWords(payload: string) {
  console.log("payload inside searchKeyWords FUNCTION", payload);
  return {
    type: DISPATCHES.SEARCH_KEYWORD_SAGA,
    payload,
  };
}

export function searchStatisticsSaga(payload: string) {
  return {
    type: DISPATCHES.SEARCH_STATISTICS_SAGA,
    payload,
  };
}

export function setClickedItem(payload: string) {
  return {
    type: DISPATCHES.SET_CLICKED_ITEM,
    payload,
  };
}

export function searchResults(payload: string) {
  return {
    type: DISPATCHES.SEARCH_RESULT_SAGA,
    payload,
  };
}
